{
  "CapabilitiesAffected": "Capacità interessate:",
  "ShowRelated": "Mostra {relatedCount} correlato/i"
}
